export enum FadeDirection {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface FadeBackgroundProps {
  direction?: FadeDirection;
}
